var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        version: "1.1",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    },
    [
      _c("path", { attrs: { fill: "none", d: "M0,0h24v24h-24Z" } }),
      _vm._v(" "),
      _c("g", [
        _c("path", {
          attrs: {
            d:
              "M5,0h-3c-1.103,0 -2,0.896 -2,2v10c0,1.103 0.897,2 2,2h3c1.103,0 2,-0.897 2,-2v-10c0,-1.104 -0.897,-2 -2,-2Zm-3,12v-10h3l0.001,10h-3.001Z",
            transform: "translate(16, 5)"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M12,0h-10c-1.103,0 -2,0.896 -2,2v7c0,1.103 0.897,2 2,2h4v1h-2v2h6v-2h-2v-1h4c1.103,0 2,-0.897 2,-2v-7c0,-1.104 -0.897,-2 -2,-2Zm-10,9v-7h10l0.001,7h-10.001Z",
            transform: "translate(1, 5)"
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }